import { supabase } from './supabase';

// As fotos do bucket 'fichas' são privadas; para exibi-las no navegador
// é preciso gerar uma URL temporária (assinada) a partir do caminho salvo.
export async function urlFotoFicha(caminho: string | null): Promise<string | null> {
  if (!caminho) return null;
  const { data } = await supabase.storage.from('fichas').createSignedUrl(caminho, 3600);
  return data?.signedUrl || null;
}